import { Typography } from '@mui/material';
import zeplinColor from 'theme/Color';

export const SectionHeader = ({ title }: { title: string }) => (
  <Typography variant='heading3' fontWeight='bold' sx={{ color: zeplinColor.BasicBlack }}>
    {title}
  </Typography>
);
